import { triggerExternalAuthError } from '@src/features/payments/store/payment';
import { ExternalAuthenticationProvider, ExternalAuthenticationProviderParams, ExternalAuthResult } from './types';

export interface AttemptsManagerParams extends ExternalAuthenticationProviderParams {
  maxAttempts: number;
}

export class AttemptsManager {
  static async handleAuthentication(
    provider: ExternalAuthenticationProvider,
    params: AttemptsManagerParams,
  ): Promise<ExternalAuthResult> {
    const { maxAttempts, dispatch } = params;
    let attempts = maxAttempts;

    while (attempts > 0) {
      try {
        const result = await provider.handleAuthentication(params);

        if (result.proceed || result.error) {
          return result;
        }

        attempts--;

        if (attempts <= 0) {
          return {
            proceed: false,
            error: 'tds_generic_error',
            externalAuthentication: result.externalAuthentication ?? undefined,
            externalError: result.externalError ?? undefined,
          };
        }

        // Small pause before the next attempt
        await new Promise((resolve) => setTimeout(resolve, 1000));
      } catch (error) {
        attempts--;

        if (attempts <= 0) {
          dispatch(triggerExternalAuthError());
          return {
            proceed: false,
            error: 'tds_generic_error',
            externalAuthentication: undefined,
            externalError: undefined,
          };
        }
      }
    }

    // Fallback
    return {
      proceed: false,
      error: 'tds_generic_error',
      externalAuthentication: undefined,
      externalError: undefined,
    };
  }
}
